import { Action } from '../../../common/actions/core/action';

export class OpenDoubleOptTimeoutDialogAction implements Action {
  constructor(public onResend: () => any) {}
}



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/timeout/double-opt-timeout-dialog.action.ts